import { useEffect, useMemo } from "react";
import { motion } from "framer-motion";

// A 3-second "falling sakura petals" celebration overlay shown when a course is
// mastered. Purely decorative (pointer-events-none) so it never blocks the UI.
export function PetalCelebration({ show, onDone }) {
  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => onDone?.(), 3200);
    return () => clearTimeout(t);
  }, [show, onDone]);

  const petals = useMemo(
    () =>
      Array.from({ length: 28 }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 0.9,
        duration: 2.3 + Math.random() * 1.3,
        size: 10 + Math.random() * 13,
        rotate: Math.random() * 360,
        drift: (Math.random() * 2 - 1) * 140,
        hue: Math.random() < 0.5 ? "#F9A8D4" : "#F472B6",
      })),
    []
  );

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[120] pointer-events-none overflow-hidden" data-testid="petal-celebration">
      {petals.map((p) => (
        <motion.div
          key={p.id}
          initial={{ y: -50, x: 0, opacity: 0, rotate: p.rotate }}
          animate={{ y: "112vh", x: p.drift, opacity: [0, 1, 1, 0.85], rotate: p.rotate + 380 }}
          transition={{ duration: p.duration, delay: p.delay, ease: "easeIn" }}
          style={{
            position: "absolute",
            left: `${p.left}%`,
            top: 0,
            width: p.size,
            height: p.size * 0.72,
            background: `radial-gradient(circle at 30% 30%, #FFE4F1, ${p.hue})`,
            borderRadius: "150% 0 150% 0",
            boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
          }}
        />
      ))}
    </div>
  );
}
